import { apiFetch } from "./apiClient";
import { mockApi } from "./mockData";
import { buildSpatialPayload, polygonCentroid } from "../utils/spatialSelection";

/**
 * Preferred contract (backend should implement):
 * POST /api/v1/time_series/query
 */
export async function queryTimeSeries({
  productType,
  productId,
  selection,
  dateFrom,
  dateTo,
}) {
  const spatial = buildSpatialPayload(selection);

  return apiFetch("/api/v1/time_series/query", {
    method: "POST",
    body: JSON.stringify({
      product_type: productType,
      product_id: productId,
      spatial,
      temporal: {
        date_from: dateFrom || null,
        date_to: dateTo || null,
      },
    }),
    mockHandler: () =>
      mockApi.getTimeSeries({
        productType,
        productId,
        spatial,
        dateFrom,
        dateTo,
      }),
  });
}

/**
 * Legacy point-only endpoint (fallback when POST not implemented):
 * GET /api/products/{id}/timeseries/?lon=&lat=&date_from=&date_to=
 */
export async function queryTimeSeriesLegacyPoint({
  productId,
  lon,
  lat,
  dateFrom,
  dateTo,
}) {
  const params = new URLSearchParams({
    lon: String(lon),
    lat: String(lat),
    band: "1",
  });
  if (dateFrom) params.set("date_from", dateFrom);
  if (dateTo) params.set("date_to", dateTo);

  return apiFetch(`/api/products/${productId}/timeseries/?${params}`, {
    method: "GET",
    mockHandler: () =>
      mockApi.getTimeSeries({
        productType: "NDVI",
        productId,
        spatial: { mode: "point", lon, lat },
        dateFrom,
        dateTo,
      }),
  });
}

/**
 * Tries POST (all spatial modes), then legacy GET for point selections.
 */
export async function fetchTimeSeries({ productType, productId, selection, dateFrom, dateTo }) {
  try {
    return await queryTimeSeries({ productType, productId, selection, dateFrom, dateTo });
  } catch (postError) {
    if (selection?.type === "point" && selection.lon != null && selection.lat != null) {
      return queryTimeSeriesLegacyPoint({
        productId,
        lon: selection.lon,
        lat: selection.lat,
        dateFrom,
        dateTo,
      });
    }
    if (selection?.type === "polygon" && selection.coordinates?.length >= 3) {
      const [lon, lat] = polygonCentroid(selection.coordinates);
      return queryTimeSeriesLegacyPoint({
        productId,
        lon,
        lat,
        dateFrom,
        dateTo,
      });
    }
    throw postError;
  }
}

export function mapTimeSeriesResponse(data) {
  if (!Array.isArray(data?.time_series)) {
    throw new Error("فرمت پاسخ سری زمانی نامعتبر است");
  }
  return data.time_series.map((item, index) => ({
    id: item.product_id ?? item.id ?? index,
    label:
      item.date ?? item.datetime ?? item.time ?? item.label ?? `#${index + 1}`,
    value: item.value !== null && item.value !== undefined ? Number(item.value) : null,
  }));
}
